<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-4">
        What is the ground state electron configuration for the
        <chemical-latex :content="element.name" /> atom?
      </p>

      <electron-configuration-input
        v-model="inputs.electronConfig"
        :max-n="5"
        :max-occupation="10"
        :orbital-types="['s', 'p', 'd']"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ElectronConfigurationInput from '../inputs/ElectronConfigurationInput';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'Question559',
  components: {
    ChemicalLatex,
    ElectronConfigurationInput,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        electronConfig: [],
      },
    };
  },
  computed: {
    element() {
      return this.taskState.getValueBySymbol('element').content;
    },
  },
};
</script>
